import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { BASE_URL } from '../config/api'; // Ensure BASE_URL is defined correctly

const EditTodo = () => {
    const { id } = useParams(); // Get the todo id from URL params
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [time, setTime] = useState('');
    const [status, setStatus] = useState('Pending');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    // Fetch todo data when the component mounts
    useEffect(() => {
        fetch(`${BASE_URL}todos/${id}`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    const { title, description, time, status } = data.data;
                    setTitle(title);
                    setDescription(description);
                    setTime(time);
                    setStatus(status);
                } else {
                    setError('Todo not found');
                }
            })
            .catch(error => {
                setError('Error fetching todo');
                console.error(error);
            });
    }, [id]);

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        // Prepare the updated todo data
        const updatedTodoData = {
            staff_id: 1, // Assuming staff_id is 1 for this example
            title,
            description,
            time,
            status,
        };

        // Send the updated data to the API
        fetch(`${BASE_URL}todos/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(updatedTodoData),
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    // Successfully updated todo
                    navigate('/TodoList'); // Redirect to the Todo List page
                } else {
                    setError('Failed to update todo');
                }
            })
            .catch(error => {
                setError('Error updating todo');
                console.error(error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Todo</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb"></ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Edit Todo</h4>
                            </div>
                            <div className="card-body">
                                {error && <div className="alert alert-danger">{error}</div>}
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group">
                                        <label htmlFor="title">Title</label>
                                        <input
                                            type="text"
                                            id="title"
                                            className="form-control"
                                            placeholder="Enter Todo Title"
                                            value={title}
                                            onChange={(e) => setTitle(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="description">Description</label>
                                        <textarea
                                            id="description"
                                            className="form-control"
                                            placeholder="Enter Todo Description"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            required
                                        ></textarea>
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="time">Time</label>
                                        <input
                                            type="datetime-local"
                                            id="time"
                                            className="form-control"
                                            value={time}
                                            onChange={(e) => setTime(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="status">Status</label>
                                        <select
                                            id="status"
                                            className="form-control"
                                            value={status}
                                            onChange={(e) => setStatus(e.target.value)}
                                        >
                                            <option value="Pending">Pending</option>
                                            <option value="In Progress">In Progress</option>
                                            <option value="Completed">Completed</option>
                                        </select>
                                    </div>

                                    <div className="form-group text-end">
                                        <button type="submit" className="btn btn-primary" disabled={loading}>
                                            {loading ? 'Updating...' : 'Update Todo'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditTodo;
